// extracted by mini-css-extract-plugin
export default {"Box":"home_Box__vZVxI"};